import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'awair-floor-plan-empty',
  templateUrl: './floor-plan-empty.component.html',
  styleUrls: ['./floor-plan-empty.component.scss']
})

export class FloorPlanEmptyComponent implements OnInit {

  @Output() openEditor: EventEmitter<void> = new EventEmitter<void>();

  constructor() {
  }

  ngOnInit() {
  }

  onOpenEditor(event: Event): void {
    this.openEditor.emit();
  }
}
